import config, { apiEnv } from './config.api';
import { formatUrlTrailing } from '@Utils/urlFormatting';

import { axiosWithHeaders, getService } from '@innovyze/lib_get_service';

const riskService = axiosWithHeaders({
	config,
	service: 'amRisk',
	axiosCreateOpts: {
		timeout: 15000,
	},
});

export const riskBaseUrl = formatUrlTrailing(
	getService('amRisk', config, apiEnv),
);

export default riskService;
